import React from 'react';
import HeadlessAuth from '../HeadlessAuth';
import Enroll from './Enroll';
import './style.css';
export default function ({ context = '', onAuthEvent, options = {} }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadlessAuth, { context: context, onAuthEvent: onAuthEvent, options: options, componentName: "XoOnboardingPasskey" }, (renderProps) => {
            return React.createElement(Enroll, Object.assign({}, renderProps));
        })));
}
